import { defineMessages, MessageDescriptor } from 'react-intl';
import { CatalogMasterFailReason } from '../../../../redux/api/fymAPI.types';

/**
 * The sentence of a failed master per reason. The limits are the ones of music24-media
 * (`MIN_SECONDS` = 15 s, `MEDIA_MAX_AUDIO_SECONDS` = 900 s).
 */
export const masterFailReasonMessages = defineMessages({
  decode: {
    id: 'app.sml.catalog.song.masterFailed.decode',
    defaultMessage: 'MUSIC24 cannot decode this file. Add it again as WAV, FLAC, MP3 or M4A.',
  },
  tooShort: {
    id: 'app.sml.catalog.song.masterFailed.tooShort',
    defaultMessage: 'This file is shorter than 15 s. Add the full song.',
  },
  tooLong: {
    id: 'app.sml.catalog.song.masterFailed.tooLong',
    defaultMessage: 'This file is longer than 15 min. Add a shorter file.',
  },
});

/** The sentence of the reason, or undefined when the reason is not known (show the general one). */
export function masterFailReasonMessage(
  reason: CatalogMasterFailReason | null | undefined
): MessageDescriptor | undefined {
  return reason === null || reason === undefined ? undefined : masterFailReasonMessages[reason];
}
